var hyphenPatternRegex = /-([a-z])/g;
/**
 * Converts a string to camelCase.
 *
 * @param  {String} string - The string.
 * @return {String}
 */

function camelCase(string) {
  if (typeof string !== 'string') {
    throw new TypeError('First argument must be a string');
  } // no hyphen found


  if (string.indexOf('-') === -1) {
    return string;
  } // convert to camelCase


  return string.toLowerCase().replace(hyphenPatternRegex, function (_, character) {
    return character.toUpperCase();
  });
}
/**
 * Swap key with value in an object.
 *
 * @param  {Object}   obj        - The object.
 * @param  {Function} [override] - The override method.
 * @return {Object}              - The inverted object.
 */


function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);

      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

module.exports = {
  camelCase: camelCase,
  invertObject: invertObject
};